<figure class="ip">
  <figcaption class="bk-sr-only">How the message looks on an iPhone</figcaption>
  <div class="ip__frame">
    <div class="ip__screen">
      <span class="ip__island" aria-hidden="true"></span>

      <div class="ip__status" aria-hidden="true">
        <span class="ip__clock">{{ clock }}</span>
        <span class="ip__icons">
          <svg class="ip__signal" viewBox="0 0 17 11">
            <rect x="0" y="7" width="3" height="4" rx="0.8" />
            <rect x="4.6" y="5" width="3" height="6" rx="0.8" />
            <rect x="9.2" y="2.6" width="3" height="8.4" rx="0.8" />
            <rect x="13.8" y="0" width="3" height="11" rx="0.8" />
          </svg>
          <svg class="ip__wifi" viewBox="0 0 15 11">
            <path
              d="M7.5 2.1c2.2 0 4.2.8 5.8 2.3l1.1-1.1A9.9 9.9 0 0 0 7.5.5 9.9 9.9 0 0 0 .6 3.3l1.1 1.1a8.3 8.3 0 0 1 5.8-2.3Zm0 3.1c1.4 0 2.6.5 3.6 1.4l1.1-1.1A6.8 6.8 0 0 0 7.5 3.6a6.8 6.8 0 0 0-4.7 1.9l1.1 1.1a5.2 5.2 0 0 1 3.6-1.4Zm0 3.1c.6 0 1.1.2 1.5.6L7.5 10.5 6 8.9c.4-.4.9-.6 1.5-.6Z"
            />
          </svg>
          <span class="ip__battery"><span class="ip__charge"></span></span>
        </span>
      </div>

      <header class="ip__thread" aria-hidden="true">
        <span class="bk-sym ip__back">chevron_left</span>
        <span class="ip__contact">
          <span class="ip__avatar">{{ initial }}</span>
          <span class="ip__name" [class.is-empty]="!senderId">
            {{ senderId || "Sender ID" }}<span class="bk-sym ip__chev">chevron_right</span>
          </span>
        </span>
      </header>

      <div class="ip__messages">
        <!-- Divs, not p: the console's global p rule would force Comfortaa here. -->
        @if (text.trim()) {
          <div class="ip__stamp">
            <span class="ip__stamp-kind">Text Message</span>
            <span>{{ stamp }}</span>
          </div>
          <div class="ip__bubble"><bk-sms-text [text]="text" [raw]="exact" /></div>
        } @else {
          <div class="ip__empty">{{ emptyText }}</div>
        }
      </div>

      <div class="ip__compose" aria-hidden="true">
        <span class="ip__plus"><span class="bk-sym">add</span></span>
        <span class="ip__field">Text Message · SMS<span class="bk-sym ip__mic">mic</span></span>
      </div>
      <span class="ip__home" aria-hidden="true"></span>
    </div>
  </div>
</figure>
